import React from "react";
import CollagesSelectOption from "../../common/dynamic-select-option/collages-select-option";
import SchoolsSelectOption from "../../common/dynamic-select-option/schools-select-option";

export default function DepartmentForm(props) {
    return <>
        <div className="modal modal-blur fade" id="modal-report" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Department Form</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Department Name</label>
                                <input
                                    type="text"
                                    name="DEPARTMENT"
                                    className="form-control"
                                    id="DEPARTMENT"
                                    value={props.formData.DEPARTMENT}
                                    onChange={props.onEdit}
                                    placeholder="Department Name"
                                />
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Department Code</label>
                                <input
                                    type="text"
                                    name="DEPT_CODE"
                                    className="form-control"
                                    id="DEPT_CODE"
                                    value={props.formData.DEPT_CODE}
                                    onChange={props.onEdit}
                                    placeholder="Department Code"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">College</label>
                                <CollagesSelectOption formData={props.formData} setFormData={props.setFormData}/>
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">School</label>
                                <SchoolsSelectOption formData={props.formData} setFormData={props.setFormData}/>
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Location</label>
                                <input
                                    type="text"
                                    name="LOCATION"
                                    className="form-control"
                                    id="LOCATION"
                                    value={props.formData.LOCATION}
                                    onChange={props.onEdit}
                                    placeholder="Location"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Phone Number</label>
                                <input
                                    type="number"
                                    name="TELEPHONE"
                                    className="form-control"
                                    id="TELEPHONE"
                                    value={props.formData.TELEPHONE}
                                    onChange={props.onEdit}
                                    placeholder="Phone Number"
                                />

                            </div>
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Status</label>
                                <select className="form-control" name="STATUS" id="STATUS" value={props.formData.STATUS} onChange={props.onEdit}>
                                    <option value="">Select Status</option>
                                    <option value="1">Active</option>
                                    <option value="0">In-Active</option>
                                </select>
                            </div>
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Image</label>
                                <input
                                    type="file"
                                    className="form-control form-control-solid"
                                    name="ImagePath"
                                    id="ImagePath"
                                    onChange={props.onImageChange}
                                    accept="image/*"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a href="#" id="closeModal" className="btn btn-link link-secondary" data-bs-dismiss="modal">
                            Cancel
                        </a>
                        {
                            props.IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={props.onSubmit} className="btn btn-primary ms-auto">
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24"
                                                 height="24"
                                                 viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                                                 strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                        </svg>
                                             Submit
                                        </span>
                                </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}